// Small fetch helpers so the CSRF-token lookup and JSON POST envelope aren't
// re-implemented in every upload controller.
export function csrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.content
}

export async function postJson(url, body) {
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-CSRF-Token": csrfToken() },
    body: JSON.stringify(body)
  })
}

// POST with just the CSRF token and no body (e.g. the /finalize endpoints).
export async function post(url) {
  return fetch(url, { method: "POST", headers: { "X-CSRF-Token": csrfToken() } })
}
